interface InterfaceErrorMessage {
  required: string;
  "invalid-num-chip": string;
  "invalid-format": string;
  "invalid-document-value": string,
  "invalid-document-type-value": string,
  "dni-repeat": string;
  "num-chip-repeat": string;
  "invalid-prefix": string;
  "invalid-email": string;
  "field-empty": string;
  "form-error": string;
  "server-error": string;
  "login-error": string;
  "min-error": string;
  "max-error": string;
  "number-error": string;
  "invalid-iban": string;
  "positive-number-error": string;
  "invalid-address": string;
  "document-duplicated": string;
  "max-num-of-pets": string;
  "invalid-identification": string;
  "unknow-error": string;
  "no-data": string;
  "no-type-selected": string;
  "file-not-found": string;
  "max-error-mascots-10": string;
  "max-length-policyNumber": string;
  "invalid-previous-date": string;
  "invalid-next-date": string;
  "invalid-from-date": string;
  "invalid-to-date": string;
  "invalid-month-year-date-diff": string;
  "invalid-seven-days-diff": string;
  [key: string]: string;
  "DR10-required": string;
  "DR26-required": string;
  "DR04-required": string;
  "DR11-required": string;
  "DR99-required": string;
  "MANDBANC-required": string;
}

export const ERROR_MESSAGES: InterfaceErrorMessage = {
  required: "Campo obligatorio",
  "invalid-num-chip": "El chip consta de 15 carácteres numéricos",
  "invalid-format": "Formato no válido",
  "invalid-document-dni": "El dni introducido no es válido",
  "invalid-document-value": "El Numero de documento es obligatorio al indicar Documento de identidad",
  "invalid-document-type-value": "El Documento de identidad es obligatorio al indicar Numero de documento",
  "invalid-document-type": "El Documento de identidad introducido no es válido",
  "invalid-document-due-to-birthdate": "El Documento de identidad no concuerda con la Fecha de Nacimiento",
  "dni-repeat": "DNI repetido",
  "num-chip-repeat": "Número de microchip repetido",
  "invalid-prefix": "Prefijo no válido",
  "invalid-email": "Email no válido",
  "field-empty": "Revisa que has rellenado todo correctamente",
  "form-error": "Revisa que has rellenado todo correctamente",
  "server-error": "Ha ocurrido un fallo en el servidor",
  "login-error": "Usuario no existe o password errónea",
  "login-blocked":
    "La cuenta se ha bloqueado porque han habido demasiados intentos fallidos de inicio de sesión intente de nuevo",
  "min-error": "El número no llega al mínimo",
  "max-error": "El número se pasa del máximo",
  "number-error": "Debe ser un número",
  "invalid-iban": "Iban no válido",
  "positive-number-error": "El número tiene que ser mayor de 0",
  "invalid-70-age": "El asegurado no puede ser mayor de 70 años",
  "invalid-address": "La dirección no es válida",
  "invalid-second-date": "La fecha de fin no puede menor que la de inicio",
  "invalid-first-date": "La fecha de inicio no puede ser mayor que la de fin",
  "invalid-follow-start-date":
    "La fecha de inicio de seguimiento no puede ser menor que el fin del periodo",
  "invalid-follow-end-date":
    "La fecha de fin de seguimiento no puede ser mayor que la de fin",
  "document-duplicated": "ya existe un asegurado con el documento ingresado",
  "max-num-of-pets": "máximo de mascotas a asegurar: 5",
  "invalid-identification": 'Introduce un NIF/CIF/NIE válido',
  "unknow-error": "Se ha producido un error. Inténtelo más tarde.",
  "no-data": "No hay datos.",
  "no-type-selected": "Debe escoger un tipo de fichero.",
  "file-not-found": "No se ha encontrado el fichero de recibos pendientes para el usuario actual.",
  "invalidFileType": "Tipo de documento no permitido.",
  "invalid-phone-number": "Introduzca un número válido",
  "repeated-document-number": "El número de documento ya pertenece a otro asegurado",
  "repeated-document-number-taker": "El número de documento ya pertenece al tomador",
  "repeated-document-number-insured": "El número de documento pertenece a un asegurado",
  "invalid-postal-code": "El código postal no es válido",
  'invalid-date': 'La fecha no es válida',
  '0-not-valid-percentage': 'El porcentaje no puede ser 0',
  'insured-not-beneficiary': 'El documento ingresado corresponde al asegurado',
  'iban-copago-same-as-main': 'El iban del copago agrupado debe ser diferente al del pago del seguro',
  "underage": "El tomador debe tener mínimo 18 años.",
  "no-decimals": "No puede contener decimales.",
  "unknow-error-sign-deleted": "Error al solicitar nueva firma, petición de firma anterior cancelada",
  "unknow-error-sign-not-deleted": "Error al cancelar la petición de firma existente",
  "badDate" : "Fecha de ida superior a la fecha de vuelta",
  "hocelot-verify-error": "Error al verificar correo electrónico.",
  "max-error-mascots-10": "El número máximo de mascotas a asegurar es 10",
  "max-length-policyNumber": "Longitud máxima es de 15 números",
  "one-required": "Obligatorio escoger una opción",
  "documents-nif-required": "Es obligatorio adjuntar el NIF",
  "DR10-required": "Es obligatorio adjuntar el documento DR10",
  "DR26-required": "Es obligatorio adjuntar el documento DR26",
  "DR04-required": "Es obligatorio adjuntar el documento DR04",
  "DR11-required": "Es obligatorio adjuntar el documento DR11",
  "DR99-required": "Es obligatorio adjuntar el documento DR99",
  "MANDBANC-required": "Es obligatorio adjuntar el Mandato SEPA",
  "required-SEPA": "Es obligatorio adjuntar el Mandato SEPA",
  "invalid-second-effect-date": "La fecha final de efecto no puede ser posterior a la fecha final de aplicación",
  "invalid-first-effect-date": "La fecha inicial de efecto no puede ser anterior a la fecha inicial de aplicación",
  "invalid-from-date": "La fecha DESDE no puede ser superior a la fecha HASTA.",
  "invalid-to-date": "La fecha HASTA no puede ser inferior a la fecha DESDE.",
  "invalid-month-year-date-diff": "El intervalo de fechas no puede ser superior a un año.",
  "invalid-seven-days-diff": "El intervalo de fechas no puede ser superior a 7 días.",
  "invalid-month-year-input": "Fecha no valida",
  "invalid-previous-date": "La fecha no puede ser anterior a: ", 
  "invalid-next-date": "La fecha no puede ser posterior a: ",
  "invalid-value": "El valor introducido no es válido",
  "consecutive-dashes-error": "No se permiten guiones consecutivos",
  "begin-or-end-dash-error": "El texto no debe comenzar ni terminar con guión",
  "space-around-dash-error": "No debe haber espacios antes ni después del guión",
  "not-two-characters-before-and-after-dash-error": "Debe haber al menos dos caracteres antes y después del guión",
  "not-only-letters-before-and-after-dash-error": "Antes y después del guion solo se permiten letras",
};

export const SENDA_ERROR_CODES: any = {
  AV100: "Error en los datos de operador",
  AV200: "Error en los datos de póliza",
  AV201: "Error en los Otros datos de los datos de poliza",
  AV300: "Error en los datos de Tomador",
  AV301: "Error en los datos de pago del Tomador",
  AV302: "Error en los datos de contacto del Tomador",
  AV303: "Error en los datos de domicilio del Tomador",
  AV400: "Error en los pagos",
  AV500: "Error en las campañas",
  AV600: "Error en los productos",
  AV610: "Error en los objetos de riesgo",
  AV611: "Error en los datos de asegurado de riesgo",
  AV612: "Error en los datos de contacto de asegurado",
  AV613: "Error en los datos de domicilio de asegurado",
  AV614: "Error en los datos de pago de asegurado",
  AV615: "Error en los datos del cuestionario de asegurado",
  AV616: "Error en los datos de cláusula de asegurado",
  AV617: "Error en la profesión de asegurado",
  AV620: "Error en los datos de un producto de riesgo",
  AV621: "Error en los datos de coberturas",
  AV622: "Error en los datos de cobertura de cobertura",
  AV623: "Error en los datos de sobreprimas",
  AV624: "Error en los datos de extraprimas",
  AV625: "Error en los datos de descuentos de cobertura",
  AV626: "Error en los datos de las campañas de una cobertura",
  AV627: "Error en datos de franquicia de cobertura",
  AV637: "Error en datos de viaje",
};
